import React, { useMemo, useState } from 'react';
import ApiService from '../../services/api';
import './SubscribeCapture.css';

const PHONE_REGEX = /^[0-9+\-\s()]{8,20}$/;
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const detectType = (value) => (value.includes('@') ? 'email' : 'phone');

const SubscribeCapture = () => {
  const [type, setType] = useState('email');
  const [value, setValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const placeholder = useMemo(
    () => (type === 'email' ? 'Enter your email' : 'Enter your phone number'),
    [type]
  );

  const validate = (nextType, nextValue) => {
    if (!nextValue.trim()) return false;
    return nextType === 'email'
      ? EMAIL_REGEX.test(nextValue.trim())
      : PHONE_REGEX.test(nextValue.trim());
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const normalizedType = type === 'auto' ? detectType(value) : type;
    if (!validate(normalizedType, value)) {
      setError(`Please enter a valid ${normalizedType}.`);
      return;
    }

    setLoading(true);
    try {
      await ApiService.subscribe({ type: normalizedType, value: value.trim() });
      setSuccess(true);
      setValue('');
      setTimeout(() => setSuccess(false), 2400);
    } catch {
      setError('Subscription failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="subscribe-capture" onSubmit={onSubmit}>
      <div className="subscribe-toggle" role="tablist" aria-label="Subscription type">
        <button
          type="button"
          className={`subscribe-toggle-btn ${type === 'email' ? 'active' : ''}`}
          onClick={() => setType('email')}
        >
          Email
        </button>
        <button
          type="button"
          className={`subscribe-toggle-btn ${type === 'phone' ? 'active' : ''}`}
          onClick={() => setType('phone')}
        >
          Phone
        </button>
      </div>

      <div className="subscribe-input-row">
        <input
          className="subscribe-input"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={placeholder}
          inputMode={type === 'phone' ? 'tel' : 'email'}
          autoComplete={type === 'phone' ? 'tel' : 'email'}
          aria-label={placeholder}
        />
        <button className={`subscribe-btn ${success ? 'success' : ''}`} disabled={loading}>
          {loading ? 'Submitting...' : success ? '✔ Subscribed' : 'Notify Me'}
        </button>
      </div>
      {error ? <p className="subscribe-error">{error}</p> : null}
    </form>
  );
};

export default SubscribeCapture;
